import styled from 'styled-components';
import { makeFieldContainer, makeField, makeLabel, makeHelperLine, makeHelperText, makeFieldBefore, makeFieldAfter, makeCharacterCounter, makeErrorMessage, } from './mixins';
export const FieldContainer = styled.div `
  ${props => makeFieldContainer(props)}
`;
export const Field = styled.div `
  ${props => makeField(props)}
`;
export const Label = styled.div `
  ${props => makeLabel(props)}
`;
export const HelperLine = styled.div `
  ${() => makeHelperLine()}
`;
export const HelperText = styled.span `
  ${() => makeHelperText()}
`;
export const FieldBefore = styled.div `
  ${props => makeFieldBefore(props)}
`;
export const FieldAfter = styled.div `
  ${props => makeFieldAfter(props)}
`;
export const CharacterCounter = styled.span `
  ${props => makeCharacterCounter(props)}
`;
export const ErrorMessage = styled.span `
  ${props => makeErrorMessage(props)}
`;
